import { service } from '../utils/request';

export function login(data) {
    return service({
        url: '/front/login',
        method: 'post',
        data
    });
}

export function logout(data) {
    return service({
        url: '/front/logout',
        method: 'post',
        data
    });
}